(function(window, document, undefined) {

  const
    activateEmbedProviderEventName = 'vodl_activate_embed_provider',
    minHeight = 200,
    playlistWidgetBaseClass = 'vodl-yt-playlist',
    playlistWidgetBoxClass = playlistWidgetBaseClass + '__box',
    playlistWidgetId = 'vodl-yt-playlist',
    scrollDistance = window.screen.availHeight * 0.1,
    tcfStorageKey = 'tcf-status',
    userStorageKey = 'user-status'
  ;

  let
    closeButton,
    isBreaking = false,
    isRiver = false,
    isMobile = true,
    muteButton,
    openButton,
    playerIframeWindow,
    playlistWidget,
    playlistWidgetBox,
    unmuteButton,
    maxHeight = 250
  ;

  // Logger instance with film frames emoji prefix.
  let logger = {};
  try {
    logger = new window.RussMedia.Utils.Logger(String.fromCodePoint(0x1F39E)) || { log: function() { } };
  }  catch(e) {
    logger = { log: function() { } };
  }

  // Storage access to immediately get userStatus and tcfStatus.
  let storage = {};
  try {
    storage = window.RussMedia.Utils.LocalStorage;
  } catch(e) {
    storage = {
      get: function() {
        return null;
      },
      set: function() {
        return false;
      },
      remove: function() {
        return;
      }
    };
  }



  /**
   * Inititalize everything:
   * - find the playlist widget on the page, if any
   * - attach event handlers to open/close the widget
   * - determine opening mode (click, scroll, instant)
   *
   * @return {undefined}
   */
  const init = function() {

    // Get the widget wrapper.
    playlistWidget = document.getElementById(playlistWidgetId);
    if (!playlistWidget) {
      // Nothing to do here, exit.
      logger.log('no yt playlist widget found, skipping.');
      return;
    }

    // Let's get the tcfStatus and userStatus from storage.
    // That way we may know early if we can show the video player to the user
    // by setting videoPlayer.consentGiven = true.
    let
      tcfStatus = storage.get(tcfStorageKey),
      userStatus = storage.get(userStorageKey) || {}
    ;

    let isPureSubscriber = userStatus.pureSubscriber || false;
    if (isPureSubscriber) {
      // Check on pureSubscriber first
      userStatus.consentSettings = userStatus.consentSettings || {};
      videoPlayer.consentGiven = userStatus.consentSettings.youtube || false;
      logger.log('consent for yt playlist widget from user-state:', videoPlayer.consentGiven);
    } else if (tcfStatus) {
      // If user is no pureSubscriber we still can check tcf consent.
      videoPlayer.consentGiven = true;
      logger.log('consent for yt playlist widget from tcf-state:', videoPlayer.consentGiven);
    }

    // Get the inner box of the widget.
    playlistWidgetBox = playlistWidget.querySelector('.' + playlistWidgetBoxClass);

    // isMobile and isBreaking will decide which setting we use to determine the opening mode.
    isMobile = window.matchMedia('(max-width: 37rem)').matches;
    isBreaking = playlistWidgetBox.classList.contains(playlistWidgetBoxClass + '--breaking');
    isRiver    = playlistWidgetBox.classList.contains(playlistWidgetBoxClass + '--river-widget');

    // Determine opening behaviour - click, scroll or instant.
    let openingBehaviour = 'click';
    if (isMobile) {
      openingBehaviour = playlistWidget.dataset.openingMobile || 'click';
    } else {
      openingBehaviour = playlistWidget.dataset.openingDesktop || 'click';
    }

    if (isRiver) {
      maxHeight = 420;
    }

    if (isBreaking) {
      openingBehaviour = playlistWidget.dataset.openingBreaking || 'click';
    }

    logger.log('widget inititalizing: isMobile:', isMobile, 'isBreaking:', isBreaking, 'openingBehaviour:', openingBehaviour, 'maxHeight: ' + maxHeight);

    // Add event listener for activating (the youtube) embed provider.
    document.addEventListener(activateEmbedProviderEventName, events.onActivateEmbedProvider);

    // Get the open- and closeButton and attach click event handlers.
    openButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-open');
    closeButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-close');

    if (closeButton) {
      closeButton.addEventListener('click', events.onCloseButtonClick);
    }

    if (openButton) {
      openButton.addEventListener('click', events.onOpenButtonClick);
    }

    // Get the mute- and unmuteButton and attach click event handlers.
    muteButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-audio--mute');
    unmuteButton = playlistWidget.querySelector('.' + playlistWidgetBoxClass + '-audio--unmute');

    if (muteButton) {
      muteButton.addEventListener('click', events.onMuteButtonClick);
    }

    if (unmuteButton) {
      unmuteButton.addEventListener('click', events.onUnmuteButtonClick);
    }

    // Add scroll event handler if 'scroll' is the openingBehaviour.
    if ('scroll' === openingBehaviour) {
      document.addEventListener('scroll', events.onScroll, {passive: true});
    }

    // Add a DOMContentLoaded event handler for 'isntant' openingBehaviour.
    if ('instant' === openingBehaviour) {
      document.addEventListener('DOMContentLoaded', () => {
        window.setTimeout(() => { events.onOpenButtonClick(); }, 2000);
      });
    }

  };

  /**
   * A collection of event handlers.
   *
   * @type {Object}
   */
  const events = {

    /**
     * Eventhandler for handling activation of the youtube embed provider.
     * ev.detail.provider should contain the provider slug.
     * Will set videoPlayer.consentGiven = true if provider slug is 'youtube' or '*'.
     *
     * @param  {Event} ev The event object.
     * @return {undefined}
     */
    onActivateEmbedProvider: function(ev) {

      let activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }

      if ('*' === activatedProvider || 'youtube' === activatedProvider) {
        logger.log('consent for yt playlist widget available!');

        // IF there is no consent YET, we save it now
        // Furthermore we try to start the video if the widget.isOpen().
        if (!videoPlayer.consentGiven) {
          videoPlayer.consentGiven = true;
          if (widget.isOpen()) {
            videoPlayer.start();
          }
        }
      }
    },

    /**
     * Click event handler for the closeButton.
     *  - stop the videoPlayer
     *  - close the widget
     *
     * @return {undefined}
     */
    onCloseButtonClick: function() {
      videoPlayer.stop();
      widget.close();
    },

    /**
     * Click event handler for the muteButton.
     *  - mute the videoPlayer
     *  - toggleUnmuteButton in the widget
     *
     * @return {undefined}
     */
    onMuteButtonClick: function() {
      videoPlayer.mute();
      widget.toggleUnmuteButton();
    },

    /**
     * Click event handler for the openButton.
     *  - remove scroll event handler
     *  - open the widget
     *  - start the videoPlayer with slight delay
     *
     * @return {undefined}
     */
    onOpenButtonClick: function() {
      // The possibly existing scroll event handler
      // should now be removed, as the widget was already opened manualy.
      document.removeEventListener('scroll', events.onScroll);
      widget.open();
      // Start the video with slight delay to better fit the opening transition.
      window.setTimeout(() => { videoPlayer.start(); }, 500);
    },

    /**
     * Slightly hackish way to recieve info if the (un-)mute button
     * inside the youtube player has been hit. Fortunately the
     * youtube player posts tons of message while playing.
     * This way we can keep our own custom buttons in sync with the
     * original buttons inside the player.
     *
     * This might not work anymore at some time in the future!
     *
     * Kudos: https://stackoverflow.com/a/65511524
     *
     * @param  {Event} e Event object
     * @return {undefined}
     */
    onPostMessage: function(e) {
      // We are only interested in messages from
      // the playerIframeWindow
      if (e.source === playerIframeWindow) {

        // The data needs to look smt. like this:
        // {event: 'infoDelivery', info: {muted: true}}
        let data = JSON.parse(e.data);
        if (
          data.event === 'infoDelivery' &&
          data.info &&
          data.info.hasOwnProperty('muted')
        ) {
          if (data.info.muted) {
            widget.toggleUnmuteButton();
          } else {
            widget.toggleMuteButton();
          }
        }
      }
    },

    /**
     * A throttled window resize handler to resize the videoPlayer accordingly.
     *
     * @return {undefined}
     */
    onResize: function() {
      window.clearTimeout(videoPlayer.resizeTimer);
      videoPlayer.resizeTimer = window.setTimeout(() => { videoPlayer.resize(); }, 200);
    },

    /**
     * Scroll event handler.
     * Only used if the openingBehaviour is 'scroll'.
     * Will open the widget via onOpenButtonClick() if scrollDistance is reached.
     *
     * @return {undefined}
     */
    onScroll: function() {
      if (scrollDistance < window.scrollY) {
        logger.log('onScroll: scrollDistance reached');
        events.onOpenButtonClick();
      }
    },

    /**
     * Click event handler for the unmuteButton.
     *  - unmute the videoPlayer
     *  - toggleMuteButton in the widget
     *
     * @return {undefined}
     */
    onUnmuteButtonClick: function() {
      videoPlayer.unmute();
      widget.toggleMuteButton();
    },

  };


  /**
   * Provides access to widget features like open() and close().
   *
   * @type {Object}
   */
  const widget = {
    closedClass: playlistWidgetBoxClass + '--minimized',
    openClass: playlistWidgetBoxClass + '--maximized',

    /**
     * Checks if widget is currently closed.
     *
     * @return {Boolean} true if closed, false otherwise.
     */
    isClosed: function() {
      return playlistWidgetBox.classList.contains(this.closedClass);
    },

    /**
     * Checks if widget is currently open.
     *
     * @return {Boolean} true if open, false otherwise.
     */
    isOpen: function() {
      return playlistWidgetBox.classList.contains(this.openClass);
    },

    /**
     * Closes the widget.
     *
     * @return {undefined}
     */
    close: function() {
      if (this.isClosed()) {
        return;
      }
      playlistWidgetBox.classList.add(this.closedClass);
      playlistWidgetBox.classList.remove(this.openClass);
    },

    /**
     * Opens the widget.
     *
     * @return {undefined}
     */
    open: function() {
      if (this.isOpen()) {
        return;
      }
      playlistWidgetBox.classList.add(this.openClass);
      playlistWidgetBox.classList.remove(this.closedClass);
    },

    /**
     * Shows the muteButton and hides the unmuteButton.
     *
     * @return {undefined}
     */
    toggleMuteButton: function() {
      muteButton.style.display = 'block';
      unmuteButton.style.display = 'none';
    },

    /**
     * Shows the unmuteButton and hides the muteButton.
     *
     * @return {undefined}
     */
    toggleUnmuteButton: function() {
      unmuteButton.style.display = 'block';
      muteButton.style.display = 'none';
    }
  };


  /**
   * Provides access to video player features like start() and stop().
   *
   * @type {Object}
   */
  const videoPlayer = {

    consentGiven: false,
    resizeTimer: null,
    youtubePlayer: false,


    /**
     * Will determine the 'optimalSize' of the video player by getting the available width
     * and calculating height according to the 16:9 aspect ratio.
     * minHeight and maxHeight are considered.
     *
     * @return {Object} Object with width and height properties.
     */
    getOptimalSize: function() {
      let width = playlistWidget.clientWidth;
      let height = width * 9/16;
      if (height > maxHeight) {
        height = maxHeight;
      } else if (height < minHeight) {
        // regarding youtube the player needs to have a min-height of 200px
        height = minHeight;
      }
      return { width, height };
    },

    /**
     * Returns a promise that will resolve() if
     *  - youtube API was already loaded some time before
     *  - youtube API could be loaded via script injection and indicated ready state
     * reject() will be caused by
     *  - failure while loading the youtube API
     *
     * @return {Promise} A promise
     */
    loadYoutubeApi: function() {
      return new Promise((resolve, reject) => {
        if ('undefined' === typeof(window.YT) || 'undefined' === typeof(window.YT.Player)) {

          const tag = document.createElement('script');
          tag.async = true;
          tag.src = 'https://www.youtube.com/iframe_api';
          tag.type = 'text/javascript';
          tag.onerror = function(error) {
            reject(error);
          };

          tag.onload = function() {
            window.YT.ready(function() {
              logger.log('loadYoutubeApi: YT.ready');
              resolve();
            });
          };

          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        } else {
          resolve();
        }
      });
    },

    /**
     * Returns a promise that will resolve() if
     *  - a YT.Player instance has already been created before in this.youtubePlayer OR
     *  - a YT.Player instance is newly created in this.youtubePlayer and is ready
     * reject() will be caused by
     *  - missing this.consentGiven
     *  - failure when loading the youtube API
     *
     * @return {Promise} A promise
     */
    maybeInitPlayer: function() {

      return new Promise((resolve, reject) => {

        logger.log('maybeInitPlayer....');

        if (!this.consentGiven) {
          reject(new Error('No consent for yt playlist widget given!'));
          return;
        }

        if (this.youtubePlayer) {
          logger.log('Player already inititalized');
          resolve();
          return;
        }

        let playerTarget = playlistWidgetBox.querySelector('.muteYouTubeVideoPlayer');
        let playlistId = playerTarget.getAttribute('playlist-id');
        let placeholder = playlistWidgetBox.querySelector('.vodl-yt-playlist__placeholder');
        let optimalSize = this.getOptimalSize();

        this.loadYoutubeApi().then(
          () => {
            logger.log('maybeInitPlayer: loadYoutubeApi sucessfull');
            this.youtubePlayer = new window.YT.Player(playerTarget, {
              width: optimalSize.width,
              height: optimalSize.height,
              playerVars: {
                listType:'playlist',
                list: playlistId,
                autoplay: 0,        // Auto-play the video on load
                controls: 1,        // Show pause/play buttons in player
                showinfo: 0,        // Hide the video title
                modestbranding: 1,  // Hide the Youtube Logo
                playsinline: 1,     // Controls whether videos play inline or fullscreen
                loop: 1,            // Run the video in a loop
                fs: 1,              // Hide the full screen button
                cc_load_policy: 0,  // Hide closed captions
                iv_load_policy: 3,  // Hide the Video Annotations
                autohide: 0,        // Hide video controls when playing
              },
              events: {
                onReady: (e) => {
                  placeholder.classList.remove('vodl-yt-playlist__placeholder');

                  if (e.target && e.target.g) {
                    e.target.g.style.display = 'block';
                  }

                  // We keep a reference to the player iframe window object
                  // to be later able to identify the correct source in the
                  // onPostMessage handler.
                  playerIframeWindow = e.target.getIframe().contentWindow;
                  // We trigger the muteButton once manually here. This will mute the player
                  // and set the widget buttons in the correct state.
                  events.onMuteButtonClick();
                  logger.log('maybeInitPlayer: player now ready');
                  // Attach a window resize event listener to be able to resize the player.
                  window.addEventListener('resize', events.onResize);
                  // Attach a window post message event listener to be able to find out
                  // if the players (un-)mute button was pressed.
                  window.addEventListener('message', events.onPostMessage);
                  resolve();
                }
              }
            });
          }, (error) => {
            reject(error);
          });
      });
    },

    /**
     * Mute the player by calling mute()
     * on the YT.Player instance this.youtubePlayer
     *
     * @return {undefined}
     */
    mute: function() {
      if (this.youtubePlayer) {
        this.youtubePlayer.mute();
      }
    },

    /**
     * Does the actual resizing.
     *
     * @return {undefined}
     */
    resize: function() {
      if (this.youtubePlayer) {
        let optimalSize = this.getOptimalSize();
        this.youtubePlayer.setSize(optimalSize.width, optimalSize.height);
      }
    },

    /**
     * Starts the video by:
     *  - waiting for maybeInitPlayer to resolve()
     *  - calling playVideo() on the YT.Player instance this.youtubePlayer
     *
     * @return {undefined}
     */
    start: function() {
      this.maybeInitPlayer().then(
        () => {
          logger.log('start: trying to play video');
          this.youtubePlayer.playVideo();
        },
        (error) => {
          logger.log('maybeInitPlayer failed:', error);
        }
      );
    },

    /**
     * Stops the video by calling playVideo()
     * on the YT.Player instance this.youtubePlayer
     *
     * @return {undefined}
     */
    stop: function() {
      if (this.youtubePlayer) {
        logger.log('stop: trying to stop video');
        this.youtubePlayer.stopVideo();
      }
    },

    /**
     * Unmute the player by calling unMute()
     * on the YT.Player instance this.youtubePlayer
     *
     * @return {undefined}
     */
    unmute: function() {
      if (this.youtubePlayer) {
        this.youtubePlayer.unMute();
      }
    },
  };


  // Initialization
  init();

})(window, document);
